import { PERMISSION_TYPES } from "helpers/sf_constants";

export const UI_PERMISSION_KEY = {
    MANAGE_USER_MANAGEMENT: 'MANAGE_USER_MANAGEMENT',
    MANAGE_BRANDS: 'MANAGE_BRANDS',
    MANAGE_CREATIVES: 'MANAGE_CREATIVES',
    VIEW_CHANGE_HISTORY: 'VIEW_CHANGE_HISTORY',
    MANAGE_SMART_VIEWS: 'MANAGE_SMART_VIEWS',
    MANAGE_SCHEDULED_REPORTS: 'MANAGE_SCHEDULED_REPORTS',
    EXPORT_DATA: 'EXPORT_DATA',
    VIEW_CAMPAIGNS: 'VIEW_CAMPAIGNS',
    MANAGE_CAMPAIGNS: 'MANAGE_CAMPAIGNS',
    VIEW_BILLING: 'VIEW_BILLING',
    MANAGE_BILLING: 'MANAGE_BILLING',
    EMAIL_ACTIVITY: 'EMAIL_ACTIVITY',
    VIEW_INTEGRATIONS: 'VIEW_INTEGRATIONS',
    MANAGE_INTEGRATIONS: 'MANAGE_INTEGRATIONS',
}

// BM-9524: the Integrations group is only shown in the role builder while the
// both::integration_role_permissions flag is on for the account (see getRoleBuilderFeatures).
export const INTEGRATIONS_FEATURE_GROUP_ID = 4

export const FEATURES = [
    {
        id: 1,
        name: 'Account Permissions',
        isActive: false,
        permissions: [
            {
                name: 'Manage Roles & User Management',
                ui_key: UI_PERMISSION_KEY.MANAGE_USER_MANAGEMENT,
                description: 'View/Create/Update/Delete Roles and Users',
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 1,
                        name: 'Role',

                    },
                    {
                        feature_id: 13,
                        name: 'Duplicate Role',

                    },
                    {
                        feature_id: 4,
                        name: 'User Management'
                    },
                ]
            },
            {
                name: 'Manage Brands',
                description: 'View/Create/Update/Delete Brands',
                ui_key: UI_PERMISSION_KEY.MANAGE_BRANDS,
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 11,
                        name: 'Brand'
                    }
                ]
            },
            {
                name: 'Manage Creatives',
                description: 'View/Create/Update/Delete Creatives',
                ui_key: UI_PERMISSION_KEY.MANAGE_CREATIVES,
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 6,
                        name: 'Ad Creatives',
                    },
                    {
                        feature_id: 10,
                        name: 'Duplicate Ad',
                    }
                ]
            },
            {
                name: 'Change History',
                description: 'View Change History',
                ui_key: UI_PERMISSION_KEY.VIEW_CHANGE_HISTORY,
                types: [PERMISSION_TYPES.READ],
                isActive: false,
                features: [
                    {
                        feature_id: 19, // TODO Add Backend
                        name: 'Change History'
                    }
                ]
            },
            {
                name: 'Manage Smart Views',
                description: 'View/Create/Update/Delete Smart Views',
                ui_key: UI_PERMISSION_KEY.MANAGE_SMART_VIEWS,
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 15,
                        name: 'Custom Smart View'
                    }
                ]
            },
            {
                name: 'Manage Scheduled Reports',
                description: 'View/Create/Update/Delete Scheduled Reports',
                ui_key: UI_PERMISSION_KEY.MANAGE_SCHEDULED_REPORTS,
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 18,
                        name: 'Scheduled reports'
                    }
                ]
            },
            {
                name: 'Export Data',
                description: 'Download data from various pages using export functions',
                ui_key: UI_PERMISSION_KEY.EXPORT_DATA,
                types: [PERMISSION_TYPES.READ],
                isActive: false,
                features: [
                    {
                        feature_id: 20,
                        name: 'Export Data'
                    }
                ]
            },
            {
                name: 'Email Activity',
                description: 'View Email Activity',
                ui_key: UI_PERMISSION_KEY.EMAIL_ACTIVITY,
                types: [PERMISSION_TYPES.READ],
                isActive: false,
                features: [
                    {
                        feature_id: 22,
                        name: 'Email Activity'
                    }
                ]
            },
        ]
    },
    {
        id: 2,
        name: 'Campaigns',
        isActive: false,
        permissions: [
            {
                name: 'View Campaigns',
                description: 'Read only access to Campaigns, Settings, Ad Groups, Source Settings etc.',
                ui_key: UI_PERMISSION_KEY.VIEW_CAMPAIGNS,
                types: [PERMISSION_TYPES.READ],
                isActive: false,
                features: [
                    {
                        feature_id: 2,
                        name: 'Campaign'
                    },
                    {
                        feature_id: 5,
                        name: 'Ad Group'
                    },
                    {
                        feature_id: 7,
                        name: 'Campaign Ad'
                    }
                ]
            },
            {
                name: 'Manage Campaigns',
                description: 'View/Create/Update/Delete Campaigns, Settings, Ad Groups, Source Settings etc.',
                ui_key: UI_PERMISSION_KEY.MANAGE_CAMPAIGNS,
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 2,
                        name: 'Campaign'
                    },
                    {
                        feature_id: 5,
                        name: 'Ad Group'
                    },
                    {
                        feature_id: 7,
                        name: 'Campaign Ad'
                    },
                    {
                        feature_id: 8,
                        name: 'Duplicate Campaign'
                    },
                    {
                        feature_id: 9,
                        name: 'Duplicate Ad Group'
                    },
                ]
            }
        ]
    },
    {
        id: 3,
        name: 'Billing',
        isActive: false,
        permissions: [
            {
                name: 'View Billing',
                description: 'Read only access to all the Billing pages',
                ui_key: UI_PERMISSION_KEY.VIEW_BILLING,
                types: [PERMISSION_TYPES.READ],
                isActive: false,
                features: [
                    {
                        feature_id: 17,
                        name: 'Receipt'
                    },
                ]
            },
            {
                name: 'Manage Billing',
                description: 'View/Create/Update/Delete all Billing related functions like Add/Edit Credit Card, Add Funds etc.',
                ui_key: UI_PERMISSION_KEY.MANAGE_BILLING,
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 17,
                        name: 'Receipt'
                    },

                ]
            }
        ]
    },
    {
        // BM-9524. Feature 21 = lead_integration (ad-portal-api). The logs come with View.
        id: INTEGRATIONS_FEATURE_GROUP_ID,
        name: 'Integrations',
        isActive: false,
        permissions: [
            {
                name: 'View Integrations',
                description: 'Read only access to Integrations, their stats and logs',
                ui_key: UI_PERMISSION_KEY.VIEW_INTEGRATIONS,
                types: [PERMISSION_TYPES.READ],
                isActive: false,
                features: [
                    {
                        feature_id: 21,
                        name: 'Lead Integration'
                    }
                ]
            },
            {
                name: 'Manage Integrations',
                description: 'View/Create/Update/Delete/Duplicate/Test Integrations',
                ui_key: UI_PERMISSION_KEY.MANAGE_INTEGRATIONS,
                types: [PERMISSION_TYPES.CREATE, PERMISSION_TYPES.READ, PERMISSION_TYPES.UPDATE, PERMISSION_TYPES.DELETE],
                isActive: false,
                features: [
                    {
                        feature_id: 21,
                        name: 'Lead Integration'
                    }
                ]
            }
        ]
    }
]
